(function ($) {

	$('.section--gudiance  .links__wrapper .links__title').hover(
		function () {
			let id = $(this).attr('data-index');

			$('.option-image').removeClass('active');
			$('.option-image[data-index=' + id + ']').addClass('active');

            $('.link__options').removeClass('active');
			$('.link__options[data-index=' + id + ']').addClass('active');

            $('.links__title').removeClass('active');
			$('.links__title[data-index=' + id + ']').addClass('active');
		}, function () {

		}
	);

})(jQuery);
